// extracted by mini-css-extract-plugin
module.exports = {"charge":"charge_charge_1RVeH","antiIndulged":"charge_antiIndulged_3nZDI"};